import { gql } from 'apollo-boost'

import useMutation, { mutationTypes } from '@utils/graphqlUtils'

const MUTATION = gql`
  mutation(
    $data: ManufacturerCreateInput!
  ) {
    createOneManufacturer(data: $data) {
      name
    }
  }
`

export default () => (
  useMutation(MUTATION, `Fabricante criado`, mutationTypes.CREATE)
)
